/**
 * Downloads a blob as a file with the specified filename
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

/**
 * Downloads CSV data as a file with a timestamped filename
 */
export const downloadCsvBlob = (blob: Blob, baseFilename: string = "data"): void => {
  const timestamp = new Date().toLocaleDateString();
  const filename = `${baseFilename}-${timestamp}.csv`;
  downloadBlob(blob, filename);
};
